.arrow-group {
    transform-origin: 50% 50%;
    transition: transform var(--wcs-semantic-motion-duration-feedback-base, 150ms) ease-in-out;
}

.arrow {
    fill: var(--wcs-grid-header-sort-arrow-color, transparent);
}

.desc {
    transform: rotate(180deg);
}
